import { Router } from '../RouteProvider';
export var buildRouteById = function (routeId, data) {
    var _a, _b;
    var path = (_b = (_a = Router.routes) === null || _a === void 0 ? void 0 : _a.find(function (route) { return route.id === routeId; })) === null || _b === void 0 ? void 0 : _b.path;
    if (!path) {
        console.error("Unable to find route path by id: ".concat(routeId));
        return '';
    }
    return path.split('/').reduce(function (acc, splittedPath) {
        if (!splittedPath)
            return acc;
        return (acc +
            (splittedPath.startsWith(':')
                ? "".concat(data[splittedPath.substring(1)], "/")
                : "".concat(splittedPath, "/")));
    }, '/');
};
//# sourceMappingURL=buildRouteById.js.map